import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { Dashboard } from "@/lib/api";
import { dashboardQuery } from "@/features/shared/hooks";

export function useAdminDashboard(required?: true): Dashboard;
export function useAdminDashboard(required: false): Dashboard | undefined;
export function useAdminDashboard(required = true): Dashboard | undefined {
  const { dashboard: dashboardId } = useParams();
  const dashboardQueryResult = useQuery({
    ...dashboardQuery(String(dashboardId)),
    enabled: !!dashboardId,
  });
  const dashboard = dashboardQueryResult.data;
  if (required && !dashboard) {
    throw new Error("Missing admin dashboard loader data");
  }
  return dashboard;
}
